export default "__VITE_ASSET__DziqSkXV__"